import React from "react";
import {Layout} from "antd";
import "./CommonView.scss";
import AccountBar from "../../components/AccountBar/AccountBar";
import Sidebar from "../../components/Sidebar/Sidebar";
import Footer from "../../components/Footer/Footer";

interface CommonViewProps {
    className?: string
    focusMainContent: Function
}

type Props = React.PropsWithChildren<CommonViewProps>;

const CommonView: React.FC<Props> = ({className = "", focusMainContent, children}: Props): React.ReactElement => (
    <Layout>
        <Sidebar focusMainContent={focusMainContent}/>
        <Layout>
            <AccountBar/>
            <Layout.Content className="df-content">
                <div className={`df-external-view-container ${className}`}>
                    {children}
                </div>
            </Layout.Content>
            <Footer/>
        </Layout>
    </Layout>
);

export default CommonView;
